/**
 * @author Kelnik
 *
 * News - Класс для новостей
 */

import axios from 'axios';
import tmplNews from './templates/news-list.twig';
import {Utils} from 'common/scripts/utils';

class News {
    constructor(container) {
        this.container = container;
    }

    init() {
        this._initElements();
        this._bindEvents();
    }

    _initElements() {
        this.content = this.container.querySelector('.j-news-content');
        this.more = this.container.querySelector('.j-news-more');
    }

    _bindEvents() {
        if (!this.more) {
            return;
        }

        this.more.addEventListener('click', (event) => {
            event.preventDefault();

            this._loadMore();
        });
    }

    _loadMore() {
        const formData = this._collectData();
        const action = this.more.dataset.action;

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.post(action, formData)
            .then((response) => {
                const {data} = response.data;

                if (!data.more) {
                    this._hideMore();
                }

                if (this.more && data.page_num) {
                    // eslint-disable-next-line camelcase
                    this.more.dataset.page_num = data.page_num;
                }

                if (data.news && data.news.length) {
                    Utils.insetContent(this.content, tmplNews(data));
                }

                if (data.articles && data.articles.length) {
                    Utils.insetContent(this.content, tmplNews(data));
                }
            })
            .catch((error) => {
                this._hideMore();

                console.error(error); // eslint-disable-line
            });
    }

    _collectData() {
        const formData = new FormData();

        for (const key in this.more.dataset) {
            if (Object.prototype.hasOwnProperty.call(this.more.dataset, key)) {
                formData.append(key, this.more.dataset[key]);
            }
        }

        return formData;
    }

    _hideMore() {
        if (this.more && this.more.parentNode) {
            Utils.removeElement(this.more.parentNode);
        }
    }
}

const newsElement = document.querySelector('.news');

if (newsElement) {
    new News(newsElement).init();
}
